import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  const handlePurchase = () => {
    window.location.href = 'https://centershop.store/cart/47529204318453:1?checkout';
  };
  return <section id={id} className="w-full py-16 px-4 bg-gradient-to-b from-slate-900 to-slate-800 text-white" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-800 border-2 border-amber-500/50 rounded-3xl p-8 md:p-12 shadow-2xl shadow-amber-500/10 relative overflow-hidden" data-id="element-3">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-4" />

          <div className="relative z-10 text-center" data-id="element-5">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-6">
              Recuperá tu Energía Mental Hoy
            </h2>

            <div className="flex flex-col items-center justify-center gap-2 mb-8" data-id="element-7">
              <span className="text-slate-400 text-xl line-through decoration-red-500 decoration-2" data-id="element-8">
                Antes 29.999 AR$
              </span>
              <div className="flex items-baseline gap-2" data-id="element-9">
                <span className="text-amber-400 text-5xl md:text-6xl font-extrabold" data-id="element-10">
                  6.999 AR$
                </span>
              </div>
              <span className="bg-amber-500/20 text-amber-300 px-4 py-1 rounded-full text-sm font-medium mt-2" data-id="element-11">
                Oferta Limitada - 57% OFF
              </span>
            </div>

            <div className="grid md:grid-cols-2 gap-4 text-left max-w-2xl mx-auto mb-10" data-id="element-12">
              {['Método de 7 días paso a paso', 'Acceso inmediato y de por vida', '2 Bonos Exclusivos GRATIS', 'Sin rutinas complicadas'].map((feature, i) => <div key={i} className="flex items-center gap-3" data-id="element-13">
                  <CheckCircle2 className="w-5 h-5 text-amber-500 flex-shrink-0" data-id="element-14" />
                  <span className="text-slate-200" data-id="element-15">{feature}</span>
                </div>)}
            </div>

            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={handlePurchase} className="w-full md:w-auto px-12 py-4 bg-gradient-to-r from-amber-500 to-orange-600 text-white text-xl font-bold rounded-xl shadow-lg shadow-orange-500/30 flex items-center justify-center gap-3 mx-auto hover:brightness-110 transition-all" data-id="element-16">
              EMPEZÁ HOY
              <ArrowRight className="w-6 h-6" data-id="element-17" />
            </motion.button>

            <p className="mt-6 text-slate-400 text-sm" data-id="element-18">
              Pago único. Acceso seguro. Garantía de satisfacción.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}